import { Navigate, Outlet } from "react-router-dom";


const PrivateRoutes = () => {
    const authToken = localStorage.getItem("authToken");
    let auth = {'token': authToken? true : false}

    return(
        auth.token ? <Outlet /> : <Navigate to={'/login'} />
    )
}

export default PrivateRoutes;